import { defineMessages } from 'react-intl';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';

const messages = defineMessages({
  showOriginalImageDownload: {
    id: 'Show download link for the high-resolution original image',
    defaultMessage: 'Show download link for the high-resolution original image',
  },
});

export const imageDownloadSchemaEnhancer = ({ formData, schema, intl }) => {
  if (!formData.url || !isInternalURL(formData.url)) {
    return schema;
  }

  const linkSettings = schema.fieldsets.find(
    (fieldset) => fieldset.id === 'link_settings',
  );

  if (linkSettings) {
    const openInNewTabIndex = linkSettings.fields.indexOf('openLinkInNewTab');
    linkSettings.fields = [
      ...linkSettings.fields.slice(0, openInNewTabIndex + 1),
      'showOriginalImageDownload',
      ...linkSettings.fields.slice(openInNewTabIndex + 1),
    ];
  }

  schema.properties.showOriginalImageDownload = {
    title: intl.formatMessage(messages.showOriginalImageDownload),
    type: 'boolean',
    default: false,
  };

  return schema;
};
